import dayjs from "dayjs";
import numeral from "numeral";
import { KeyboardEvent } from "react";
import { EnumStatusPriceList } from "types/price-list.type";
import { EnumInvoiceStatus } from "types/sales-order.type";
import { BASE_URL_API, OBJ_COLOR } from ".";

const stringToSlug = (str: string) => {
	var from = "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
		to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
	for (var i = 0, l = from.length; i < l; i++) {
		str = str.replace(RegExp(from[i], "gi"), to[i]);
	}

	str = str
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9\-]/g, "-")
		.replace(/-+/g, "-");

	return str;
};

export const dateFormatServer = (str: string | dayjs.Dayjs) => dayjs(str).format("YYYY-MM-DD");
export const dateTimeFormatServer = (str: string | dayjs.Dayjs) => dayjs(str).format("YYYY-MM-DDTHH:mm:ss");

export const dateFormat = (str: string | dayjs.Dayjs, full?: boolean) => (!full ? dayjs(str).format("DD/MM/YYYY") : dayjs(str).format("DD/MM/YYYY HH:mm:ss"));
export const numberFormat = (value: number) => numeral(value).format("0,0");
export const numberFormatFractionDigits = (number: number) => {
	if (Number.isInteger(number)) return numeral(number).format("0,0");

	return numeral(number).format("0,0.00");
};

export const onKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
	if (!/[0-9]/.test(event.key)) {
		event.preventDefault();
	}
};

export const handleSelectFilter = (input: string, { label }: any) => {
	return stringToSlug(label).indexOf(stringToSlug(input)) >= 0;
};

export const getUrlImage = (str: string) => `${BASE_URL_API}/uploads/${str}`;

export const translationInvoiceStatus = (str: keyof typeof EnumInvoiceStatus) => {
	if (str === "UNISSUED") {
		return "Chưa xuất";
	} else if (str === "ISSUED") {
		return "Đã xuất";
	}

	return "Đã xuất";
};

export const colorInvoiceStatus = (str: keyof typeof EnumInvoiceStatus) => {
	if (str === "UNISSUED") {
		return OBJ_COLOR.DANGER;
	} else if (str === "ISSUED") {
		return OBJ_COLOR.SUCCESS;
	}

	return OBJ_COLOR.SUCCESS;
};

export const translationStatusPriceList = (status: keyof typeof EnumStatusPriceList) => {
	if (status === "valid") return "Đang áp dụng";

	if (status === "invalid") return "Hết hiệu lực";

	return "Chưa áp dụng";
};

export const colorStatusPriceList = (status: keyof typeof EnumStatusPriceList) => {
	if (status === "valid") return OBJ_COLOR.SUCCESS;

	if (status === "invalid") return OBJ_COLOR.DANGER;

	return OBJ_COLOR.INFO;
};

export const getChickenTypeString = (itemCode?: string, chickenType?: number) => {
	if (!itemCode || !chickenType) return "";

	const itemCodeDefaultList = ["CNG0000601", "CNG0000304", "CNG0000305"];

	if (itemCodeDefaultList.includes(itemCode) && chickenType === 2) return "A";

	return chickenType;
};

export const getChickenTypeLabel = (itemCode?: string, chickenType?: number, deliveryNoteName?: string | null) => deliveryNoteName || getChickenTypeString(itemCode, chickenType);
